import { useEffect, useRef, useState } from 'react';

import { copy } from '../../../components/util/copy';
import logger from '../../../utils/logger';
import { trackCopyEmailClicked } from '../tracking';

/** How long a copy stays confirmed, in ms. */
const CONFIRMATION_MS = 2000;

/** Nullable so callers can run this above their own guard on a missing address. */
export const useCopyEmail = (email: string | null) => {
  const [copied, setCopied] = useState(false);
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  useEffect(() => () => clearTimeout(timer.current), []);

  const onCopy = async () => {
    if (email === null) return;

    try {
      await copy(email);
    } catch (error) {
      // Confirming a refused write sends the seller off to paste nothing.
      logger.error('Failed to copy a customer email address', { error });
      return;
    }

    trackCopyEmailClicked();
    setCopied(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setCopied(false), CONFIRMATION_MS);
  };

  return { copied, onCopy };
};
